<div class="price-rule-view" *ngIf="priceRule">
  <!-- Compact Header -->
  <div class="bg-white border-round shadow-1 p-3 mb-4">
    <div class="flex align-items-center justify-content-between">
      <div class="flex align-items-center">
        <div class="bg-primary-100 border-round p-3 mr-4">
          <i class="pi pi-tag text-primary text-3xl"></i>
        </div>
        <div>
          <div class="text-lg font-bold text-900 m-0">
            {{priceRule.name}}
            <span *ngIf="!priceRule.isActive" class="text-red-500">[Not Active]</span>
          </div>
          <div class="flex align-items-center gap-3 mt-2">
            <p-tag [value]="priceRule.priceType"
                   [severity]="priceRule.priceType === 'WEEKDAY' ? 'success' : 'warning'"
                   styleClass="text-sm">
            </p-tag>
            <span class="text-lg text-600">•</span>
            <app-day-range-display [days]="priceRule.days" styleClass="text-base"></app-day-range-display>
            <span class="text-lg text-600">•</span>
            <span class="text-lg text-600">{{priceRule.tstart}}–{{priceRule.tend}}</span>
            <p-tag *ngIf="priceRule.specialPrice"
                   [value]="priceRule.specialPrice ? 'SPECIAL': 'NORMAL'"
                   [severity]="priceRule.specialPrice ? 'warn' : 'info'"
                  styleClass="text-sm">
            </p-tag>
            <span class="text-lg text-600">•</span>
            <span class="text-lg text-600">{{priceRule.minperson}}–{{priceRule.maxperson}} golfers</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Grid -->
  <div class="grid">
    <!-- Pricing Section -->
    <div class="col-12 lg:col-8">
      <div class="grid">
        <!-- Green Price (Golfdigg) -->
        <div class="col-12 sm:col-6">
          <p-card styleClass="bg-blue-50 h-full">
            <div class="flex align-items-center justify-content-between mb-3">
              <div class="w-3rem"></div>
              <span class="text-lg font-semibold text-blue-500 text-center">Price At Golfdigg</span>
              <i class="w-3rem pi pi-star text-yellow-500 text-lg"></i>
            </div>
            <div class="flex justify-content-center">
              <div class="text-right">
                <div class="text-2xl font-bold text-blue-900">{{priceRule.map[1]?.sale| number }}</div>
                <div class="text-base text-blue-500">Base: {{priceRule.map[1]?.base | number}}</div>
                <div class="text-base text-gray-500 line-through">Course: {{priceRule.originalPrice | number}}</div>
              </div>
            </div>
          </p-card>
        </div>

        <!-- Thailand Elite (TPC) -->
        <div class="col-12 sm:col-6" *ngIf="priceRule.map[2]">
          <p-card styleClass="bg-orange-50 h-full">
            <div class="flex align-items-center justify-content-between mb-3">
              <span class="text-lg font-semibold text-orange-500">Thailand Elite</span>
              <i class="pi pi-building text-orange-600 text-lg"></i>
            </div>
            <div class="text-sm">
              <div class="flex justify-content-between mb-2">
                <span class="font-medium">Member:</span>
                <span class="font-bold text-lg">{{priceRule.map[2]?.sale | number}}</span>
              </div>
              <div class="flex justify-content-between mb-2">
                <span>Base(M):</span>
                <span>{{priceRule.map[2]?.base | number}}</span>
              </div>
              <div class="flex justify-content-between mb-2" *ngIf="priceRule.map[2]?.saleGuest >= 0">
                <span class="font-medium">Guest:</span>
                <span class="font-bold text-lg">{{priceRule.map[2]?.saleGuest | number}}</span>
              </div>
              <div class="flex justify-content-between" *ngIf="priceRule.map[2]?.baseGuest >= 0">
                <span>Base(G):</span>
                <span>{{priceRule.map[2]?.baseGuest | number}}</span>
              </div>
            </div>
          </p-card>
        </div>

        <!-- Agent OTA Tiers -->
        <div class="col-12" *ngIf="priceRule.map[3] || priceRule.map[4] || priceRule.map[5] || priceRule.map[6]">
          <div class="bg-yellow-50 p-card">
              <div class="flex align-items-center p-3">
                <i class="pi pi-users text-yellow-600 mr-3 text-xl"></i>
                <span class="text-lg font-semibold text-yellow-500">Agent OTA Tiers</span>
              </div>
            <div class="grid">
              <div class="col-3" *ngIf="priceRule.map[3]">
                <div class="text-center bg-white border-round p-3">
                  <div class="text-sm text-gray-500">Tier 0</div>
                  <div class="font-bold">{{priceRule.map[3]?.base | number}}</div>
                </div>
              </div>
              <div class="col-3" *ngIf="priceRule.map[4]">
                <div class="text-center bg-white border-round p-3">
                  <div class="text-sm text-gray-500">Tier 1</div>
                  <div class="font-bold">{{priceRule.map[4]?.base | number}}</div>
                </div>
              </div>
              <div class="col-3" *ngIf="priceRule.map[5]">
                <div class="text-center bg-white border-round p-3">
                  <div class="text-sm text-gray-500">Tier 2</div>
                  <div class="font-bold">{{priceRule.map[5]?.base | number}}</div>
                </div>
              </div>
              <div class="col-3" *ngIf="priceRule.map[6]">
                <div class="text-center bg-white border-round p-3">
                  <div class="text-sm text-gray-500">Tier 3</div>
                  <div class="font-bold">{{priceRule.map[6]?.base | number}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Hot Deal Pricing -->
        <div class="col-12" *ngIf="priceRule.enableHotDeal">
          <div class="bg-pink-50 border-1 border-pink-200 p-card">
            <div class="flex align-items-center p-3">
              <i class="pi pi-bolt text-pink-600 mr-3 text-xl"></i>
              <span class="text-lg font-semibold text-pink-500">Hot Deal Pricing</span>
            </div>
            <div class="grid">
              <div class="col-4" *ngIf="priceRule.hotDealPrices[3]">
                <div class="text-center bg-white border-round p-1">
                  <div class="font-semibold">3 Hours</div>
                  <div class="font-bold text-lg text-pink-600">{{priceRule.hotDealPrices[3]?.price | number}}</div>
                  <div class="text-sm text-500">Base: {{priceRule.hotDealPrices[3]?.base | number}}</div>
                </div>
              </div>
              <div class="col-4" *ngIf="priceRule.hotDealPrices[6]">
                <div class="text-center bg-white border-round p-1">
                  <div class="font-semibold">6 Hours</div>
                  <div class="font-bold text-lg text-pink-600">{{priceRule.hotDealPrices[6]?.price | number}}</div>
                  <div class="text-sm text-500">Base: {{priceRule.hotDealPrices[6]?.base | number}}</div>
                </div>
              </div>
              <div class="col-4" *ngIf="priceRule.hotDealPrices[9]">
                <div class="text-center bg-white border-round p-1">
                  <div class="font-semibold">9 Hours</div>
                  <div class="font-bold text-lg text-pink-600">{{priceRule.hotDealPrices[9]?.price | number}}</div>
                  <div class="text-sm text-500">Base: {{priceRule.hotDealPrices[9]?.base | number}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Info Panel -->
    <div class="col-12 lg:col-4">
      <div class="bg-white border-round shadow-1 p-4 mb-3">
        <div class="mb-4">
          <div class="text-lg font-semibold text-500 mb-3">Schedule</div>
          <div class="flex justify-content-center">
            <app-date-range-status
              styleClass="flex gap-2 mt-2"
              [showDash]="true"
              [start]="priceRule.season.start"
              [end]="priceRule.season.end">
            </app-date-range-status>
          </div>
        </div>
      </div>

      <div class="bg-white border-round shadow-1 p-4">
        <!-- Features -->
        <div class="mb-4">
          <div class="text-lg font-semibold text-500 mb-3">Features</div>
          <div class="grid">
            <div class="col-4">
              <div class="text-center">
                <i class="pi" [ngClass]="priceRule.party ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'"
                   style="font-size: 1.5rem"></i>
                <div class="text-sm mt-1 font-medium">Party</div>
              </div>
            </div>
            <div class="col-4">
              <div class="text-center">
                <i class="pi" [ngClass]="priceRule.freeCart ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'"
                   style="font-size: 1.5rem"></i>
                <div class="text-sm mt-1 font-medium">Free Cart</div>
              </div>
            </div>
            <div class="col-4">
              <div class="text-center">
                <i class="pi" [ngClass]="priceRule.freeCaddy ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'"
                   style="font-size: 1.5rem"></i>
                <div class="text-sm mt-1 font-medium">Free Caddy</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Cart Settings -->
        <div *ngIf="priceRule.cartSetting?.active" class="mb-4">
          <div class="text-lg font-semibold text-500 mb-3">Cart Settings</div>
          <div class="bg-blue-50 border-round p-3">
            <div class="text-sm">
              <div class="flex justify-content-between mb-2">
                <span class="font-medium">Required:</span>
                <i class="pi" [ngClass]="priceRule.cartSetting.require ? 'pi-check text-green-500' : 'pi-times text-red-500'"></i>
              </div>
              <div class="flex justify-content-between mb-2">
                <span class="font-medium">Max Require:</span>
                <i class="pi" [ngClass]="priceRule.cartSetting.maxRequire ? 'pi-check text-green-500' : 'pi-times text-red-500'"></i>
              </div>
              <div class="flex justify-content-between mb-2">
                <span class="font-medium">Sale:</span>
                <i class="pi" [ngClass]="priceRule.cartSetting.sale ? 'pi-check text-green-500' : 'pi-times text-red-500'"></i>
              </div>
              <div class="flex justify-content-between mb-2">
                <span class="font-medium">Original:</span>
                <span class="font-semibold">{{priceRule.cartSetting.priceOriginal | currency}}</span>
              </div>
              <div class="flex justify-content-between mb-2">
                <span class="font-medium">Sale Price:</span>
                <span class="font-semibold text-green-600">{{priceRule.cartSetting.priceSale | currency}}</span>
              </div>
              <div class="flex justify-content-between">
                <span class="font-medium">Base:</span>
                <span class="font-semibold">{{priceRule.cartSetting.priceBase | currency}}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Last Updated -->
        <div class="text-sm text-500 border-top-1 border-200 pt-3 flex gap-2">
          <div class="mb-1">Created:</div>
          <div class="text-base text-500">{{priceRule.created | date:'dd/MM/yyyy'}}</div>
        </div>
        <div class="text-sm text-500 border-top-1 border-200 pt-3 flex gap-2">
          <div class="mb-1">Updated:</div>
          <div class="text-base text-500">{{priceRule.updated | date:'dd/MM/yyyy'}}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Email Remarks Section -->
  <div *ngIf="priceRule.notice?.en || priceRule.notice?.th || priceRule.note" class="mt-4">
    <p-accordion>
      <p-accordionTab header="Email Remarks & Notes" [selected]="false">
        <div class="grid">
          <div class="col-12 md:col-6" *ngIf="priceRule.notice?.en">
            <div class="mb-4">
              <div class="text-lg font-semibold text-blue-600 mb-3">Email Remark (EN)</div>
              <div class="bg-blue-50 border-1 border-blue-200 border-round p-4">
                <div class="text-base text-500">{{priceRule.notice.en}}</div>
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6" *ngIf="priceRule.notice?.th">
            <div class="mb-4">
              <div class="text-lg font-semibold text-blue-600 mb-3">Email Remark (TH)</div>
              <div class="bg-blue-50 border-1 border-blue-200 border-round p-4">
                <div class="text-base text-500">{{priceRule.notice.th}}</div>
              </div>
            </div>
          </div>

          <div class="col-12" *ngIf="priceRule.note">
            <div class="mb-4">
              <div class="text-lg font-semibold text-orange-600 mb-3">Notes</div>
              <div class="bg-orange-50 border-1 border-orange-200 border-round p-4">
                <div class="text-base text-500">{{priceRule.note}}</div>
              </div>
            </div>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>

  <!-- Event Logs Section -->
  <div *ngIf="events && events.length > 0" class="mt-3">
    <app-event-log-viewer [events]="events"
                          [title]="'Price Rule Events for ' + priceRule.name"
                          [showHeader]="true">
    </app-event-log-viewer>
  </div>
</div>

<!-- Loading State -->
<div *ngIf="!priceRule" class="flex align-items-center justify-content-center p-8">
  <p-progressSpinner strokeWidth="3" animationDuration="1s"></p-progressSpinner>
  <span class="ml-3 text-600">Loading price rule...</span>
</div>
